import { useState } from 'react';
export default function useIsHovered(forceHovered) {
  var [hovered, setHovered] = useState(false);
  var [isTouchEvent, setIsTouchEvent] = useState(false);
  var eventHandlers = {
    onTouchStart() {
      setIsTouchEvent(true);
    },
    onTouchEnd() {
      setTimeout(() => {
        setIsTouchEvent(false);
      }, 30);
    },
    onMouseOver() {
      // problem is explained here: https://stackoverflow.com/questions/39474904/how-to-identify-if-a-mouseover-event-object-came-from-a-touchscreen-touch
      if (!isTouchEvent) {
        setHovered(true);
      }
    },
    onMouseOut() {
      setHovered(false);
    }
  };
  return [forceHovered !== undefined ? forceHovered : hovered, eventHandlers];
}
//# sourceMappingURL=index.js.map